module.exports = __webpack_public_path__ + "static/media/icon-pencil.0e18e65d.svg";